import { fromPairs, map, pipe, curryN } from 'lodash/fp';
/**
 * extractObjectValuesToArray - extracts values for given keys and place them into a nested array
 *
 * @param {string} key - name of key for setting object key
 * @param {string} value - name of the key for setting object value
 * @param {Array} array - array of objects
 *
 * @returns {Array} an array of extracted values for given keys
 *
 * @example
 * extractObjectValuesToArray('key', 'value', [ { key: 'weight', value: 80, type: 'tree' } ])
 * // [ [ 'weight', 80 ] ]
 */

export var extractObjectValuesToArray = function extractObjectValuesToArray(key, value, array) {
  return map(function (row) {
    return [row[key], row[value]];
  }, array);
};
/**
 * mapArrayToKeyValueObject - creates a key : value object from provided array
 *
 * @param {string} key - name of key for setting object key
 * @param {string} value - name of the key for setting object value
 * @param {Array} array - array of objects
 *
 * @returns {object} extracted values of specified keys
 *
 * @example
 * mapArrayToKeyValueObject('key', 'value', [ { key: 'weight', value: 80, type: 'tree' } ])
 * // { weight: 80, height: 300 }
 */

export var mapArrayToKeyValueObject = curryN(3, pipe([function (key, value, array) {
  return extractObjectValuesToArray(key, value, array);
}, fromPairs]));
export default mapArrayToKeyValueObject;